import React from 'react'

type Props = {
  contentType?: string
  onClick?: any
}

export const TR: React.FC<Props> = ({contentType, onClick, children}) => {
  return (
    <tr
      className={
        '' +
        (contentType === 'head' ? 'fs-7 gs-0 text-start text-muted text-uppercase fw-bolder' : '')
      }
      onClick={onClick}
    >
      {children}
    </tr>
  )
}
